import React from 'react';
import x from '../../images/js/x'

class Alerts extends React.Component {

    state = {
        divName: "alerts bad",
        buttonName: "alertButton bad",
        timeout: null
    }

    // two timeouts, alertcontainer handles how long the notification should last
    // alerts timeout, the one in here, handles when the transition out should happen
    // alerts container 0--------100
    // alerts           0---50  

    componentDidMount() {
        let timeout = setTimeout(this.changeDivName, 7000)
        this.setState({
            timeout,
            divName: (this.props.messageType) ? "alerts good" : "alerts bad",
            buttonName: (this.props.messageType) ? "alertButton good" : "alertButton bad"
        })
    }

    changeDivName = () => {
        clearTimeout(this.state.timeout)
        this.setState({divName: this.state.divName + " leaving", timeout: null})
    }

    earlyHide = (event) => {
        event.preventDefault()
        clearTimeout(this.state.timeout)
        this.setState({ divName: this.state.divName + " leaving", timeout: null })
    }

    render() {
        return (<div className={this.state.divName}>
            <div className="alertMessage" style={{float: "left", width: "80%", height: "100%",}}>
                <p style={{position: "relative", top: "5px", margin: "0px", paddingLeft: "10px", fontSize: "16px"}} >{this.props.message}</p>
            </div>
            <div className="alertX" style={{ float: "left", width: "18%", height: "100%", verticalAlign: "middle" }}>
                {x("white", "5px", this.earlyHide, "25px")}
            </div>
        </div>)
    }

}

export default Alerts